import Container from './TagsBatchEdit.container';
import TagsBatchEdit from './TagsBatchEdit';

export default Container(TagsBatchEdit);
